import React from 'react'
import { closeModal, openCommonModal } from 'sb-modal'
import { RefundStatus } from 'typings/graphql'

import { Box } from 'components/_new/layout'
import Text from 'components/_new/typography/Text/Text'

import messages from './messages'


type RefundModalProps = {
  status: RefundStatus
  isBillingDay1stEnabled: boolean
}


export const openRefundModal = ({ status, isBillingDay1stEnabled }: RefundModalProps) => (
  new Promise<'REFUND' | 'RECEIVE'>((resolve) => {
    const choose = (refund: boolean) => () => {
      resolve(refund ? 'REFUND' : 'RECEIVE')
    }

    let textMessage = messages.text

    if (status === 'AVAILABLE') {
      textMessage = isBillingDay1stEnabled
        ? messages.textForNotChargedUser1st
        : messages.textForNotChargedUser
    }

    const receiveButtonMessage = status === 'AVAILABLE' ? messages.receiveButtonForNotChargedUser : messages.receiveButton

    openCommonModal({
      className: 'humbleBgColor',
      iconName: 'assembly',
      iconColor: 'brand-30',
      title: messages.title,
      text: textMessage,
      content: (
        <Box mt={16}>
          <Text size="16-24" color="gray-80" message={messages.commonText} />
        </Box>
      ),
      primaryButton: {
        title: receiveButtonMessage,
        onClick: choose(false),
      },
      secondaryButton: {
        title: messages.refundButton,
        onClick: choose(true),
      },
      onClose: choose(false),
      dataTestId: 'refundModal',
    })
  })
)

export const closeRefundModal = () => closeModal('common')
